import { render, staticRenderFns } from "./CreateAssetGroupContent.vue?vue&type=template&id=2d6cc486&scoped=true&"
import script from "./CreateAssetGroupContent.vue?vue&type=script&lang=js&"
export * from "./CreateAssetGroupContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssetGroupContent.vue?vue&type=style&index=0&id=2d6cc486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cc486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6cc486')) {
      api.createRecord('2d6cc486', component.options)
    } else {
      api.reload('2d6cc486', component.options)
    }
    module.hot.accept("./CreateAssetGroupContent.vue?vue&type=template&id=2d6cc486&scoped=true&", function () {
      api.rerender('2d6cc486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AssetTracking/ModalComponents/CreateAssetGroupContent.vue"
export default component.exports